import { ColumnActionsMode, IColumn, IconButton } from "@fluentui/react";

import { ContractColumns } from "./contractColumns/ContractColumns";

import { Contract } from "@/components/Contracts/contract.interface";
import { DrawerActions } from "@/components/Shared/CustomDrawer";
import { ContractItem } from "@/modules/Contracts/types";

interface BuildContractColumnsProps {
  listItems?: ContractItem[];
  canRead: boolean;
  canListShipments: boolean;
  openDrawer: (action: DrawerActions) => void;
  setSelectedItemId: (id: number) => void;
}

export function BuildContractColumns({
  listItems,
  canRead,
  canListShipments,
  openDrawer,
  setSelectedItemId
}: BuildContractColumnsProps) {
  const columns: IColumn[] = ContractColumns({
    listItems,
    canRead,
    canListShipments
  });

  if (canRead) {
    columns.unshift({
      key: "view",
      name: "view",
      fieldName: "view",
      minWidth: 60,
      maxWidth: 60,
      columnActionsMode: ColumnActionsMode.disabled,
      isIconOnly: true,
      onRender: (item: Contract) => {
        return (
          <IconButton
            onClick={() => {
              setSelectedItemId(item.id);
              openDrawer(DrawerActions.VIEW);
            }}
            iconProps={{ iconName: "View" }}
            title={"Visualizar Contrato"}
          />
        );
      }
    });
  }

  return columns;
}
